"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var load_more_1 = require("../features/load-more");
function init() {
    init_load_more();
}
exports.init = init;
function init_load_more() {
    var _a;
    var orders_container = document.getElementById('orders-container');
    if (orders_container) {
        var params = {
            // parameter
            page: "",
            date_from: 0,
            date_to: 0,
            per_page: (_a = orders_container.dataset.perPage) !== null && _a !== void 0 ? _a : 10,
            sort_by: "created_at",
        };
        (0, load_more_1.initialize_load_more)('orders', params).catch(function (e) { return console.error(e); });
    }
}
